
define('css!ui/animable/pulsable/css/pulse',[],function(){});
